import type { CreditScoreSource } from '@makemydeal/dr-platform-types';
import type { LenderCreditSource } from '@makemydeal/dr-dash-types';

const CREDIT_SCORE_SOURCE_LABELS: Record<CreditScoreSource, string> = {
    dealerDefault: 'Dealer Default',
    selfReported: 'Self Reported'
};

export const getCreditScoreSourceLabel = (source: CreditScoreSource | undefined): string =>
    CREDIT_SCORE_SOURCE_LABELS[source ?? 'selfReported'];

const LENDER_CREDIT_SOURCE_LABELS: Record<LenderCreditSource, string> = {
    softpull: 'Soft Pull',
    dealerDefault: 'Dealer Default',
    selfReported: 'Self Reported'
};

export const getLenderCreditSourceLabel = (source: LenderCreditSource | undefined): string =>
    LENDER_CREDIT_SOURCE_LABELS[source ?? 'selfReported'];
